const EVENTS = {
  identify: "analytics.identify",
  setUserAttributes: "analytics.set_user_attributes",
  click: "analytics.click",
  pageview: "analytics.pageview",
  view: "analytics.view",
  log: "analytics.log",
}

export default EVENTS
